import React from 'react';
import { InView } from 'react-intersection-observer';

const PosterFeature = () => {
  return (
    <div className="bg-gray-950 py-20">
      <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center gap-12">
        {/* Left Section */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`w-full lg:w-1/2 ${inView ? 'animate__animated animate__fadeInLeft' : 'opacity-0'}`}
            >
              <h2 className="text-4xl sm:text-5xl font-bold mb-6">
                <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                  Ready-Made Posters for Every Occasion
                </span>
              </h2>
              <p className="text-xl text-gray-300 mb-8 font-semibold">
                Festival greetings, business promotions, and social media posts—all ready in minutes
              </p>
              <div className="space-y-4">
                {[
                  "Choose from thousands of professionally designed templates",
                  "Covers all Indian festivals, national days, and special occasions",
                  "One-tap customization—add your logo, name, or brand details",
                  "Share directly to WhatsApp, Instagram, Facebook, and more"
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <p className="text-gray-300 text-lg">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </InView>

        {/* Right Section */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`w-full lg:w-1/2 flex justify-center ${inView ? 'animate__animated animate__fadeInRight' : 'opacity-0'}`}
            >
              <img
                src="https://img.freepik.com/premium-vector/full-stack-developer-job-2d-illustration-concept_151150-27976.jpg"
                alt="Festival Posters"
                className="w-full max-w-xl h-auto object-cover rounded-2xl shadow-2xl shadow-purple-500/20"
              />
            </div>
          )}
        </InView>
      </div>
    </div>
  );
};

export default PosterFeature;